import menu_icon from "./menu_icon.png";
import hero_1 from "./hero_1.jpg";
import hero_2 from "./hero_2.jpg";
import about_us from "./about_us.jpg";
import testimonial_1 from "./testimonial_1.jpg";
import testimonial_2 from "./testimonial_2.jpg";
import testimonial_3 from "./testimonial_3.jpg";
import star_icon from "./star_icon.png";
import star_dull from "./star_dull.png";
import stripe_logo from "./stripe_logo.png";
import razorpay_logo from "./razorpay_logo.png";
import profile_icon from "./profile_icon.png";
import cross_icon from "./cross_icon.png";
import bin_icon from "./bin_icon.png";
import menu_white from "./menu_white.svg";
import sun from "./sun.svg";
import moon from "./moon.svg";
import leaves from "./leaves.png";
import flowers from "./flowers.png";
import logo from "./logo.png";
import cart from "./cart.svg";
import star1 from "./star1.svg";
import star2 from "./star2.svg";
import insta from "./insta.svg";
import search from "./search.svg";
import quotes from "./quotes.svg";
import facebook from "./facebook.svg";
import linkedin from "./linkedin.svg";
import arrow from "./arrow.svg";
import back_icon from "./back_icon.svg";
import maps from "./maps.svg";
import blur from "./blur.svg";
import blur_2 from "./blur_2.svg";
import blur_3 from "./blur_3.svg";
import error_icon from "./error_icon.svg";
import success_icon from "./success_icon.svg";
import paystack_logo from "./paystack_logo.svg";
import story_img from "./story_img.jpg";

const images = {
  menu_icon,
  menu_white,
  cross_icon,
  sun,
  moon,
  leaves,
  cart,
  star1,
  star2,
  insta,
  flowers,
  search,
  quotes,
  facebook,
  linkedin,
  arrow,
  star_icon,
  star_dull,
  profile_icon,
  back_icon,
  maps,
  blur,
  blur_2,
  blur_3,
  bin_icon,
  stripe_logo,
  razorpay_logo,
  about_us,
  hero_1,
  hero_2,
  testimonial_1,
  testimonial_2,
  testimonial_3,
  error_icon,
  success_icon,
  paystack_logo,
  logo,
  story_img,
};

export default images;
